import React from "react";
import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import { CheckCircle } from "mosaic-react-icons";

const ImportCompleteView = ({
    i18n,
    onBackToList,
    onNextFramework,
    nextFrameworkEnabled = false,
}) => (
    <SovosBox
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 8,
            px: 3,
        }}
    >
        <SovosBox sx={{ position: "relative", mb: 4 }}>
            <SovosBox
                sx={{
                    width: 140,
                    height: 140,
                    borderRadius: "50%",
                    bgcolor: "success.light",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <SovosBox
                    sx={{
                        width: 80,
                        height: 96,
                        border: "2px dashed",
                        borderColor: "primary.main",
                        borderRadius: 1.5,
                        bgcolor: "background.paper",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        p: 1.5,
                        justifyContent: "center",
                    }}
                >
                    {[1, 2, 3, 4].map((row) => (
                        <SovosBox
                            key={row}
                            sx={{ height: 7, borderRadius: 0.5, bgcolor: "grey.200" }}
                        />
                    ))}
                </SovosBox>
            </SovosBox>
            <SovosBox
                sx={{
                    position: "absolute",
                    bottom: 6,
                    right: 6,
                    bgcolor: "success.main",
                    borderRadius: "50%",
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 2,
                }}
            >
                <CheckCircle sx={{ color: "white", fontSize: 22 }} />
            </SovosBox>
        </SovosBox>
        <SovosTypography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
            {i18n`Import complete`}
        </SovosTypography>
        <SovosTypography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: "center" }}>
            {i18n`Your data has been imported and audit rule will be run automatically`}
        </SovosTypography>
        <SovosBox sx={{ display: "flex", gap: 1.5 }}>
            <SovosButton variant="outlined" onClick={onBackToList}>
                {i18n`Back to the list`}
            </SovosButton>
            <SovosButton
                variant="contained"
                onClick={onNextFramework}
                disabled={!nextFrameworkEnabled}
            >
                {i18n`Next Data framework`}
            </SovosButton>
        </SovosBox>
    </SovosBox>
);

export default ImportCompleteView;
